import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { useStoreServiceApi } from "@/api/hooks/storeService.hook";
import { StocksResponse } from "@/api/hooks/storeService.types";
import { DefaultFor } from "@/api/mappers/default.mapper";
import { Tooltip } from "@/components/General/Tooltip/tooltip.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { StorePickerModalStates } from "@/utils/enums";

import { useDeliveryContext } from "../../context/delivery.context";

type OnlyAvailableInStoreProps = {
    displayEcommerceText: boolean;
};

const OnlyAvailableInStore = ({
    displayEcommerceText
}: OnlyAvailableInStoreProps) => {
    const { t } = useGranite();
    const { sku, visibilityType, isBoxSoldOut, setStorePickerModalState } =
        useDeliveryContext();

    const toolTipText = t("ecommerce.lookupAvailableStores.tooltip.text");
    const toolTipTitle = t("ecommerce.lookupAvailableStores.tooltip.title");

    const [{ data }] = useStoreServiceApi({
        url: `/stocks/:sku`,
        method: "GET",
        urlParams: {
            sku
        },
        mapper: DefaultFor<StocksResponse>()
    });

    const onOpenStorePicker = () => {
        !isBoxSoldOut &&
            setStorePickerModalState(() => StorePickerModalStates.Open);
    };

    return (
        <div>
            {displayEcommerceText && (
                <div className={cn("tw:flex")}>
                    <Button
                        size="lg"
                        outline={true}
                        color="primary"
                        fullWidth={true}
                        className={cn("tw:pointer-events-none")}
                        disabled
                    >
                        {t(`ecommerce.text.${visibilityType}`)}
                    </Button>
                </div>
            )}
            {data?.inStock && (
                <div className={cn("tw:flex tw:mt-4")}>
                    <Button
                        test="onlyAvailableInStore-button-lookupAvailableStores"
                        className={cn("tw:p-0")}
                        color={"link"}
                        type="button"
                        onClick={onOpenStorePicker}
                    >
                        {t("ecommerce.text.lookupAvailableStores")}
                    </Button>
                    <Tooltip
                        innerHTML={toolTipText}
                        title={toolTipTitle}
                    />
                </div>
            )}
        </div>
    );
};

export { OnlyAvailableInStore };
